var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',[_c('h2',{staticClass:"text-center mt-4 mb-5"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"question__description text-center",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }